export default "__VITE_ASSET__2b6e3fc3__"